
import { Box, Typography, CircularProgress } from "@mui/material";


function ProgressBar({ progress }) {


    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{
                    color: "#e0e0e0",
                    position: "absolute",
                }}
            />
            <CircularProgress
                variant="determinate"
                value={progress}
                size={30}
                thickness={5}
                sx={{ color: "#08AE55" }}
            />

            <Box
                position="absolute"
                top={0}
                left={0}
                bottom={0}
                right={0}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <div className="text-[8px] text-[var(--primary-text-color)]"> {`${progress}%`}</div>
            </Box>
        </Box>
    );
}

export default ProgressBar;
